import { IEnv } from './env.type'

export const environment: IEnv = {
  PRODUCTION: false,
  API_PREFIX: 'https://dev.api.denistiaglin.com',
  SOCKET_PREFIX: 'wss://dev.api.denistiaglin.com',
}
